import { toast } from 'react-toastify';
import { orgPacksFun } from '../../../api/infoAPI';

export const getOrganizerTrips = async (type, id, limit, offset, setHasMore, setData, setLoading) => {
    setLoading(true);
    try {
        const res = await orgPacksFun(type, id, limit, offset);
        if (res.data.length === 0) {
            setHasMore(false);
        } else {
            // setData((prev) => [...prev, ...res.data]);
            setData(res.data);
        }
        setLoading(false);
    } catch (error) {
        toast.error('error', error);
        setLoading(false);
    }
};
